/* eslint-disable no-extend-native */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import 'react-select-search/style.css'
import TextField from '@mui/material/TextField';
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from "firebase/storage";
import Button from '@mui/material/Button';
import { CloudUpload, PortableWifiOffSharp } from '@mui/icons-material';
import Cropper from 'react-easy-crop';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slider from '@mui/material/Slider';
import Snackbar from '@mui/material/Snackbar';
import { useCookies } from "react-cookie";
import { deleteVenue, addVenue, updateVenue } from '../services/venue-services';
import { Input } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { refreshAuthToken } from '../services/auth-services';

export default function CreateVenueForm(props) {
    const [success, setSuccess] = useState(false)
    const [file, setFile] = useState()
    const [imageFile, setImageFile] = useState()
    const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
    const storage = getStorage();
    const [venueName, setVenueName] = useState("")
    const [venueAddress, setVenueAddress] = useState("")
    const [venuePostcode, setVenuePostcode] = useState("")
    const [venueLatitude, setVenueLatitude] = useState("")
    const [venueLongitude, setVenueLongitude] = useState("")
    const [venueDescription, setVenueDescription] = useState("")
    const [venueTel, setVenueTel] = useState("")
    const [editMode, setEditMode] = useState(false);
    const [venueId, setVenueId] = useState("")
    const [successMessage, setSuccessMessage] = useState("Venue successfully created")
    const [venueURL, setVenueURL] = useState("")
    const { v4: uuidv4 } = require('uuid');
    const [loading, setLoading] = useState(false);
    const [imageFileValidationError, setImageFileValidationError] = useState(false)
    const [cropModalOpen, setCropModalOpen] = useState(false)
    const [cropSrc, setCropSrc] = useState(null)
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [pendingFile, setPendingFile] = useState(null)

    useEffect(() => {
        const loadVenues = async () => {
            if (props.editMode) {
                console.log(props)
                setEditMode(props.editMode)
                var data = props.venueData[0]
                setVenueId(data.venueId)
                setVenueName(data.venueName)
                setVenueAddress(data.venueAddress)
                setVenuePostcode(data.venuePostcode)
                setVenueLatitude(data.venueLatitude)
                setVenueLongitude(data.venueLongitude)
                setVenueDescription(data.venueDescription)
                setVenueTel(data.venueTel)
                setFile(data.venueImage)
                setVenueURL(data.venueUrl)
            }
        }
        loadVenues();
    }, [])

    const clearForm = () => {
        setVenueName("")
        setVenueAddress("")
        setVenuePostcode("")
        setVenueTel("")
        setVenueLatitude("")
        setVenueLongitude("")
        setFile("")
        setImageFile("")
        setVenueURL("")
        setVenueDescription("")
        setLoading(false)
    }

    const validateForm = () => {
        if(venueName === undefined || venueName.length === 0) {
            window.alert("Venue Name is empty and is required")
            setLoading(false)
            return true;
          }
        
        if(venueAddress === undefined || venueAddress.length === 0) {
            window.alert("Venue Address is empty and is required")
            setLoading(false)
            return true;
        }
        if(venueDescription === undefined || venueDescription.length === 0) {
            window.alert("Venue Description is empty and is required")
            setLoading(false)
            return true;
        }

        if(venuePostcode === undefined || venuePostcode.length === 0) {
            window.alert("Venue Postcode is empty and is required")
            setLoading(false)
            return true;
          }

          if(venueTel === undefined || venueTel.length === 0) {
            window.alert("Venue Telephone is empty and is required")
            setLoading(false)
            return true;
          }
          if(venueLatitude === undefined || venueLatitude.length === 0) {
            window.alert("Venue Latitude is empty and is required")
            setLoading(false)
            return true;
          }
          if(venueLongitude === undefined || venueLongitude.length === 0) {
            window.alert("Venue Longitude is empty and is required")
            setLoading(false)
            return true;
          }
          if(editMode === false){
            if(imageFile === undefined || imageFile.length === 0){
                window.alert("Venue Image is empty and is required")
                setLoading(false)
                return true;
            }
          }
    }

    const handleFormSubmit = () => {
        setLoading(true)
        var validation = validateForm()
        if(validation){
          return;
        }
        if (!editMode) {
            const data = {
                venueName: venueName,
                venueAddress: venueAddress,
                venuePostcode: venuePostcode,
                venueTel: venueTel,
                venueLatitude: venueLatitude,
                venueLongitude: venueLongitude,
                venueDescription: venueDescription,
                venueUrl: venueURL
            };
            console.log(typeof(imageFile))
            if(typeof(imageFile) === "object"){
                console.log("first here")
                handleCloudUpload().then((downloadUrl) => {
                    console.log("here")
                    data.venueImage = downloadUrl
                    refreshAuthToken().then((token) => {
                        addVenue(data, token).then((response) => {
                            console.log(response)
                            clearForm()
                            setSuccess(true);
                            console.log(props.refreshVenues())
                            props.refreshVenues()
                        }).catch(error => {
                            console.log(error)
                            setSuccessMessage("There was an error creating your venue")
                            setSuccess(true)
                        })
                    })
                })
            }else{
                refreshAuthToken().then((token) => {
                    addVenue(data, token).then((response) => {
                        console.log(response)
                        clearForm()
                        setSuccess(true);
                        console.log(props.refreshVenues())
                        props.refreshVenues()
                    }).catch(error => {
                        console.log(error)
                        setSuccessMessage("There was an error creating your venue")
                        setSuccess(true)
                    })
                })
            }
         }
        else {
            if (imageFile === undefined) {
                console.log("not uploading image")
                const data = {
                    venueId: venueId,
                    venueName: venueName,
                    venueAddress: venueAddress,
                    venuePostcode: venuePostcode,
                    venueTel: venueTel,
                    venueLatitude: venueLatitude,
                    venueLongitude: venueLongitude,
                    venueDescription: venueDescription,
                    venueUrl:venueURL,
                    venueImage: file,
                };
                console.log(data)
                refreshAuthToken().then((token) => {
                    updateVenue(data, token).then((response) => {
                        console.log(response)
                        setSuccessMessage("Updated venue successfully")
                        setSuccess(true);
                        props.refreshVenues()
                    }).catch(error => {
                        console.log(error)
                        setSuccessMessage("There was an error updating your venue")
                        setSuccess(true)
                    })
                })
            }
            else {
                handleCloudUpload().then((downloadUrl) => {
                    const data = {
                        venueId: venueId,
                        venueName: venueName,
                        venueAddress: venueAddress,
                        venuePostcode: venuePostcode,
                        venueTel: venueTel,
                        venueLatitude: venueLatitude,
                        venueLongitude: venueLongitude,
                        venueDescription: venueDescription,
                        venueUrl:venueURL,
                        venueImage: downloadUrl,
                    };
                    console.log(data)
                    refreshAuthToken().then(token => {
                        updateVenue(data, token).then((response) => {
                            console.log(response)
                            setSuccessMessage("Updated venue successfully")
                            setSuccess(true);
                            props.refreshVenues()
                        }).catch(error => {
                            console.log(error)
                            setSuccessMessage("There was an error updating your venue")
                            setSuccess(true)
                        })
                    })
                })
            }
        }
    }

    const displayCaputredImage = () => {
        if (file) {
            return (
                <Row>
                    <Col>
                        <img src={file} alt="Venue" style={{ maxHeight: 200 }} />
                    </Col>
                </Row>

            )
        }
    }


    // Create the file metadata
    /** @type {any} */
    const metadata = {
        contentType: 'image/jpeg'
    };

    const handleCloudUpload = () => {
        return new Promise((resolve) => {
            const stableFile = new File([imageFile], imageFile.name, { type: imageFile.type });
            var fileName = uuidv4()
            const storageRef = ref(storage, `/images/${fileName}`);
            const uploadTask = uploadBytesResumable(storageRef, stableFile, metadata);

            uploadTask.on('state_changed',
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    switch (snapshot.state) {
                        case 'paused':
                            break;
                        case 'running':
                            break;
                    }
                },
                (error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            break;
                        case 'storage/canceled':
                            // User canceled the upload
                            break;

                        // ...

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            break;
                    }
                },
                () => {
                    // Upload completed successfully, now we can get the download URL
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        resolve(downloadURL);
                    });
                }
            )
        })
    };

    const cropAndCompressToFile = (imageSrc, pixelCrop, originalName) => {
        return new Promise((resolve) => {
            const MAX_SIZE = 1200;
            const QUALITY = 0.85;
            const img = new Image();
            img.onload = () => {
                const cropWidth = Math.max(1, Math.round(pixelCrop?.width || img.width));
                const cropHeight = Math.max(1, Math.round(pixelCrop?.height || img.height));
                const sourceX = Math.max(0, Math.round(pixelCrop?.x || 0));
                const sourceY = Math.max(0, Math.round(pixelCrop?.y || 0));
                const scale = Math.min(1, MAX_SIZE / Math.max(cropWidth, cropHeight));
                const outputWidth = Math.max(1, Math.round(cropWidth * scale));
                const outputHeight = Math.max(1, Math.round(cropHeight * scale));

                const canvas = document.createElement('canvas');
                canvas.width = outputWidth;
                canvas.height = outputHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(
                    img,
                    sourceX, sourceY,
                    cropWidth, cropHeight,
                    0, 0, outputWidth, outputHeight
                );
                canvas.toBlob(
                    (blob) => {
                        const outName = originalName.replace(/\.[^.]+$/, '.jpg');
                        resolve(new File([blob], outName, { type: 'image/jpeg' }));
                    },
                    'image/jpeg',
                    QUALITY
                );
            };
            img.src = imageSrc;
        });
    };

    const handlePreviewAndImageFile = (file) => {
        setImageFileValidationError(false)
        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = () => {
                setCropSrc(reader.result);
                setPendingFile(file);
                setCrop({ x: 0, y: 0 });
                setZoom(1);
                setCropModalOpen(true);
            };
            reader.readAsDataURL(file);
        } else {
            setImageFileValidationError(true)
        }
    };

    const handleCropConfirm = async () => {
        const compressed = await cropAndCompressToFile(cropSrc, croppedAreaPixels, pendingFile.name);
        setFile(URL.createObjectURL(compressed));
        setImageFile(compressed);
        setCropModalOpen(false);
        setCropSrc(null);
        setPendingFile(null);
    };

    const handleCropCancel = () => {
        setCropModalOpen(false);
        setCropSrc(null);
        setPendingFile(null);
    };

    const handleDeleteVenue = () => {
        deleteVenue(venueId, props.refreshToken).then((response) => {
            setSuccessMessage("Venue deleted successfully")
            setSuccess(true)
            props.refreshVenues()
        }).catch((error) => {
            console.log(error)
            setSuccessMessage("There was an issue deleting your venue")
            setSuccess(true)
        })
    }

    const displayDeleteVenueButton = () => {
        if (editMode) {
            return (
                <Row>
                    <Col className='mb-3'>
                        <Button component="label" // Turn the button into a label
                        startIcon={<DeleteIcon />} // Optional: Add an icon (e.g., CloudUploadIcon)
                        onClick={() => handleDeleteVenue()} variant='contained'>Delete Venue</Button>
                    </Col>
                </Row>
            )
        }

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccess(false);
    };


    return (
        <Container style={{ backgroundColor: "white", paddingTop: 50, paddingBottom: 50, borderRadius: 10 }}>
            <Snackbar
                open={success}
                autoHideDuration={5000}
                onClose={handleClose}
                message={successMessage}
            />
            <Row>
                <Col md={6} className='mb-3'>
                    <TextField
                        sx={{ width: "100%" }}
                        id="outlined-basic"
                        label="Venue Name"
                        variant="outlined"
                        value={venueName}
                        onChange={(event) => {
                            setVenueName(event.target.value);
                        }} />
                </Col>
                <Col md={6} className='mb-3'>
                    <TextField
                        sx={{ width: "100%" }}
                        id="outlined-basic"
                        label="Venue Telephone"
                        variant="outlined"
                        value={venueTel}
                        onChange={(event) => {
                            setVenueTel(event.target.value);
                        }} />
                </Col>
            </Row>
            <Row>
                <Col md={6} className='mb-3'>
                    <TextField sx={{ width: "100%" }} id="outlined-basic" multiline rows={4} label="Venue Address" variant="outlined" value={venueAddress}
                        onChange={(event) => {
                            setVenueAddress(event.target.value);
                        }} />
                </Col>
                <Col md={6} className='mb-3'>
                    <TextField
                        sx={{ width: "100%" }}
                        id="outlined-basic"
                        label="Venue Postcode"
                        variant="outlined"
                        value={venuePostcode}
                        onChange={(event) => {
                            setVenuePostcode(event.target.value);
                        }} />
                </Col>
            </Row>
            <Row>
                <Col md={6} className='mb-3'>
                    <TextField
                        sx={{ width: "100%" }}
                        id="outlined-basic"
                        label="Venue Latitude"
                        variant="outlined"
                        value={venueLatitude}
                        onChange={(event) => {
                            setVenueLatitude(event.target.value);
                        }} />
                </Col>
                <Col md={6} className='mb-3'>
                    <TextField
                        sx={{ width: "100%" }}
                        id="outlined-basic"
                        label="Venue Longitude"
                        variant="outlined"
                        value={venueLongitude}
                        onChange={(event) => {
                            setVenueLongitude(event.target.value);
                        }} />
                </Col>
                <Col md={6} className='mb-3'>
                    <TextField sx={{ width: "100%" }} id="outlined-basic" multiline rows={4} label="Venue Description" variant="outlined" value={venueDescription}
                        onChange={(event) => {
                            setVenueDescription(event.target.value);
                        }} />
                </Col>
                <Col md={6} className='mb-3'>
                    <TextField sx={{ width: "100%" }} id="outlined-basic" label="Venue Website" variant="outlined" value={venueURL}
                        onChange={(event) => {
                            setVenueURL(event.target.value);
                        }} />
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col>
                    <Button
                        variant="contained"
                        color="primary"
                        component="label" // Turn the button into a label
                        startIcon={<CloudUpload />} // Optional: Add an icon (e.g., CloudUploadIcon)

                    >
                        Upload Image
                        <Input type="file" id="imageUpload" style={{ display: 'none' }} accept="image/*" onChange={(e) => (handlePreviewAndImageFile(e.target.files[0]))} /> {/* Visually-hidden input */}
                    </Button>
                     {/* Display error message if imageFileValidationError is true */}
                {imageFileValidationError && (
                  <p style={{ color: "red", fontSize: 12, marginTop: 8 }}>
                    Invalid file type. Please upload an image.
                  </p>
                )}
                </Col>
            </Row>
            <Row>
                <Col className='mb-3'>
                    {displayCaputredImage()}
                </Col>
            </Row>
            <Row>
                <Col className='mb-3'>
                    <Button component="label" // Turn the button into a label
                        startIcon={<CloudUpload />} // Optional: Add an icon (e.g., CloudUploadIcon)
                        onClick={() => handleFormSubmit()} variant="contained"
                        disabled={loading || imageFileValidationError}>Submit</Button>
                        
                </Col>


            </Row>
            {displayDeleteVenueButton()}
            <Dialog open={cropModalOpen} onClose={handleCropCancel} maxWidth="sm" fullWidth>
                <DialogTitle>Crop Image</DialogTitle>
                <DialogContent>
                    <div style={{ position: 'relative', width: '100%', height: 320, background: '#333' }}>
                        <Cropper
                            image={cropSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={3/2}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)}
                        />
                    </div>
                    <div style={{ marginTop: 16 }}>
                        <p style={{ marginBottom: 4, fontSize: 13 }}>Zoom</p>
                        <Slider
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.05}
                            onChange={(_, v) => setZoom(v)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCropCancel}>Cancel</Button>
                    <Button onClick={handleCropConfirm} variant="contained">Crop &amp; Use</Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}